import { render, staticRenderFns } from "./NewStepsView.vue?vue&type=template&id=e71a05a4"
import script from "./NewStepsView.vue?vue&type=script&lang=js"
export * from "./NewStepsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports